import { render, staticRenderFns } from "./ContactsFragmentDesktopContactListParents.vue?vue&type=template&id=2a3c2bce&scoped=true&"
import script from "./ContactsFragmentDesktopContactListParents.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktopContactListParents.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFragmentDesktopContactListParents.vue?vue&type=style&index=0&id=2a3c2bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c2bce",
  null
  
)

export default component.exports